/**
 * End2 appears in BOTH tours: once as the guided journey's terminal step (exclusive, so the
 * user acknowledges the ending before anything else can surface), and again in
 * guidedJourneyEnded as the persistent low-priority 24h banner. The copy is shared here.
 */
export const END2_SPEECH_BUBBLE =
  'Remember, there\'s no "correct" way to watch zoolife! Your all-access pass lets you see ' +
  'everything for 24h. Tomorrow, the animals will still be here waiting for you to come back and revisit!';

export const END2_RESTART_BUTTON = {
  label: 'Restart the tour again',
  restartTour: true,
  restartTourId: 'guidedJourney',
} as const;
